module.exports = __webpack_public_path__ + "static/media/blog-post.1.9f0d9fdf.md";